;(function ($, window, document, undefined) {

  // Create the defaults once
  var pluginName = 'beDynamicFields',
    defaults = {
      repopulate: false,
      loadingContainer: '.o-form__loading',
      apiUrl: window.location.origin,
      submitOnChange: false,
      type: 'POST'
    };

  // The actual plugin constructor
  function Plugin(element, options) {
    this.element = element;
    this.$element = $(element);

    this.options = $.extend({}, defaults, options);

    this._defaults = defaults;
    this._name = pluginName;

    this.formData = {};

    this.init();
  }

  Plugin.prototype.init = function () {
    var Plugin = this;
    var fieldTypeSelect = Plugin.$element.find('select[name="field_type"]');
    var fieldOptions = Plugin.$element.find('.js-beDynamicFields--options');

    Plugin.makeChangesToSave();

    Plugin.hideOptions(fieldOptions, fieldTypeSelect);

    fieldTypeSelect.on('change', function () {
      Plugin.hideOptions(fieldOptions, fieldTypeSelect)
    });

    Plugin.addOption();

    Plugin.removeOption();

  };

  Plugin.prototype.makeChangesToSave = function () {
    var Plugin = this;

    Plugin.$element.find(':input').on('input', function () {
      Plugin.$element.find('.js-beDynamicFields--save').prop('disabled', false);
    });
  }

  Plugin.prototype.addOption = function () {
    var Plugin = this;

    Plugin.$element.find('.js-beDynamicFields--options__add').on('click', function (e) {
      e.preventDefault();

      var indexAttr = Plugin.$element.find('.js-beDynamicFields--option').last().attr('data-index');

      var index = isNaN(indexAttr) ? 0 : parseInt(indexAttr) + 1;

      $.get(window.location.origin + '/dynamic-fields/fields/option-template', {
        index: index
      }).success(function (tmp) {

        var template = $.templates(tmp);

        var tmpHtml = template.render();

        Plugin.$element.find('.js-beDynamicFields--options--translations').append(tmpHtml);

        Plugin.$element.find('.js-beDynamicFields--option__remove').on('click', function () {
          $(this).parents('.js-beDynamicFields--option').remove();
        });

        Plugin.makeChangesToSave();

      });


    });

  };

  Plugin.prototype.hideOptions = function (fieldOptions, fieldTypeSelect) {
    var Plugin = this;

    if (fieldTypeSelect.val() === 'select') {
      fieldOptions.show();
    } else {
      fieldOptions.hide();
      Plugin.$element.find('.js-beDynamicFields--options--translations').children().remove();
    }
  }

  Plugin.prototype.removeOption = function () {
    var Plugin = this;

    Plugin.$element.find('.js-beDynamicFields--option__remove').on('click', function () {
      $(this).parents('.js-beDynamicFields--option').remove();
    });
  }

  // A really lightweight plugin wrapper around the constructor,
  // preventing against multiple instantiations
  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName,
          new Plugin(this, options));
      }
    });
  }

})(jQuery, window, document);